module.exports = __webpack_public_path__ + "img/home_banner1.ebd87c93.png";